import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.css';
import './App.css';

// MSAL imports
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { iamApiRequest } from "./authConfig";

import Header from './components/Header';
import Footer from './components/Footer';

import OathToken from './components/OathToken';

class App extends Component {

  authRequest = {
    ...iamApiRequest
  };

  render() {
    return (
      <MsalProvider instance={this.props.pca}>
      <div>
          <Router>
          <MsalAuthenticationTemplate 
            interactionType={InteractionType.Redirect} 
            authenticationRequest={this.authRequest} 
          >
                <Header />
                <div className="container">
                    <Switch> 
                          <Route path = "/" exact component = {OathToken} />
                          <Route path = "/oathtokens" component = {OathToken} />
                    </Switch>
                </div>
                <Footer />
          </MsalAuthenticationTemplate>
          </Router>
      </div>
      </MsalProvider>
    );
  }
}

export default App;
